import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Button,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { Formik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { EmailError, PasswordError } from "../../utils";
import {
  useAuthCreateUserWithEmailAndPassword,
  useAuthSendEmailVerification,
} from "@react-query-firebase/auth";
import { addUser, auth, db } from "../../firebase";
import Form from "../../components/Form";

const GatherMetadataFormSchema = yup.object({
  usage: yup
    .string("Enter a value")
    .oneOf(
      [
        "policymaking",
        "resource_allocation",
        "investments",
        "advocacy",
        "academic_research",
        "personal_research",
        "csr_esg_strategy",
        "other",
      ],
      "Invalid selection"
    )
    .required("Primary use is required"),
});

const GatherMetadataForm = ({ email, onSubmit }) => {
  return (
    <Formik
      initialValues={{
        usage: "",
      }}
      onSubmit={(values, { setSubmitting, setFieldError, setStatus }) => {
        addUser({
          email,
          usage: values.usage,
        });
        onSubmit();
      }}
      validationSchema={GatherMetadataFormSchema}
    >
      {({ values, touched, errors, handleChange, handleSubmit }) => (
        <Form>
          <TextField
            margin="dense"
            fullWidth
            name="usage"
            label="Primary use of Social Progress Imperative data?"
            id="usage"
            value={values.usage}
            onChange={handleChange}
            error={touched.usage && !!errors.usage}
            helperText={(touched.usage && errors.usage) || " "}
            required
            select
          >
            <MenuItem value={"policymaking"}>Policymaking</MenuItem>
            <MenuItem value={"resource_allocation"}>
              Resource allocation
            </MenuItem>
            <MenuItem value={"investments"}>Investments</MenuItem>
            <MenuItem value={"advocacy"}>Advocacy</MenuItem>
            <MenuItem value={"academic_research"}>Academic research</MenuItem>
            <MenuItem value={"personal_research"}>Personal research</MenuItem>
            <MenuItem value={"csr_esg_strategy"}>CSR or ESG strategy</MenuItem>
            <MenuItem value={"other"}>Other</MenuItem>
          </TextField>

          <Button
            onClick={handleSubmit}
            fullWidth
            variant="contained"
            sx={{ mt: "8px" }}
          >
            Submit
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default GatherMetadataForm;
